import {
    STOCKSTATUS
} from '../types';

const initialState = {
    stockstatus: false
}

export default function LoadingState(state = initialState, action) {
    switch (action.type) {
        case STOCKSTATUS:
            return {
                stockstatus: action.status
            }
        default:
            return state;
    }
}